import { render } from "./BlockFull.vue?vue&type=template&id=0da009a7&scoped=true"
import script from "./BlockFull.vue?vue&type=script&lang=js"
export * from "./BlockFull.vue?vue&type=script&lang=js"

import "./BlockFull.vue?vue&type=style&index=0&id=0da009a7&scoped=true&lang=css"

import exportComponent from "/usr/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da009a7"]])

export default __exports__